module.exports = fetch;


//////////////////
// WEBPACK FOOTER
// external "fetch"
// module id = 261
// module chunks = 1